export function updateTierProgressBar() {
  const container = document.querySelector('.tiered-progress-bar');
  if (!container) return;

  const subtotal = parseFloat(container.dataset.cartSubtotal);
  const thresholds = JSON.parse(container.dataset.thresholds);
  const maxThreshold = parseFloat(container.dataset.maxThreshold);
  const progressFill = container.querySelector('#tier-progress-fill');

  if (!progressFill || !thresholds.length) return;

  const sorted = [...thresholds].sort((a, b) => Number(a.threshold) - Number(b.threshold));

  function getPosition(t) {
    if (t.position_override != null && t.position_override !== '') {
      return Math.min(100, Math.max(0, parseFloat(t.position_override)));
    }
    return maxThreshold > 0 ? Math.min(100, (Number(t.threshold) / maxThreshold) * 100) : 100;
  }

  let prevPos = 0;
  let prevThresh = 0;

  for (let i = 0; i < sorted.length; i++) {
    const thresh = Number(sorted[i].threshold);
    const pos = getPosition(sorted[i]);

    if (subtotal < thresh) {
      const ratio = prevThresh === thresh ? 0 : (subtotal - prevThresh) / (thresh - prevThresh);
      progressFill.style.width = `${prevPos + (pos - prevPos) * ratio}%`;
      return;
    }

    prevPos = pos;
    prevThresh = thresh;
  }

  progressFill.style.width = '100%';
}

export function initTierProgressBar() {
  window.addEventListener('resize', updateTierProgressBar);

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    new MutationObserver((mutations) => {
      for (const m of mutations) {
        for (const node of m.addedNodes) {
          if (node.nodeType !== 1) continue;
          if (node.classList?.contains('tiered-progress-bar') || node.querySelector?.('.tiered-progress-bar')) {
            requestAnimationFrame(updateTierProgressBar);
            return;
          }
        }
      }
    }).observe(cartDrawer, { childList: true, subtree: true });
  }

  requestAnimationFrame(updateTierProgressBar);
}
